module.exports = __webpack_public_path__ + "img/fromages.e90adc84.svg";